import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ApiService } from '../../../../../utility/api.service'
import { ToastCtl } from '../../../../components/custom/toast/ToastCtl'

export const fetchProperties = createAsyncThunk('properties/fetchAll', async ({ filter = null, fields = null, offset = 0, limit = 250, sort }, { rejectWithValue }) => {
    const query = new URLSearchParams({
        filter: filter ? JSON.stringify(filter) : '',
        fields: fields ? JSON.stringify(fields) : '',
        offset,
        limit,
        sort: sort ? JSON.stringify(sort) : '',
    });

    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/properties?${query}`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { properties: Object.values(response.data), count: response.count }
})

export const fetchProperty = createAsyncThunk('property/fetch', async ({ id, fields = null }, { rejectWithValue }) => {
    const query = fields ? `fields=${JSON.stringify(fields)}` : ''
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/property/${id}?${query}`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { property: response.data.property }
})

export const updateProperty = createAsyncThunk('property/update', async ({ id, payload, showToast = true }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/property/${id}`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { property: response.data.property, showToast }
})

const initialState = {
    properties: [],
    selectedProperty: null,
    loading: false,
    submitting: false,
    error: null,
    count: 0
}

const propertySlice = createSlice({
    name: 'properties',
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    extraReducers: {
        [fetchProperties.pending]: (state) => {
            state.loading = true
        },
        [fetchProperties.fulfilled]: (state, { payload }) => {
            state.properties = payload.properties
            state.count = payload.count
            state.loading = false
        },
        [fetchProperties.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [fetchProperty.pending]: (state) => {
            state.loading = true
        },
        [fetchProperty.fulfilled]: (state, { payload }) => {
            state.selectedProperty = payload.property
            state.loading = false
        },
        [fetchProperty.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [updateProperty.pending]: (state) => {
            state.submitting = true
        },
        [updateProperty.fulfilled]: (state, { payload }) => {
            state.selectedProperty = payload.property
            state.submitting = false

            if (payload.showToast) {
                ToastCtl.success('Daten wurden erfolgreich gespeichert')
            }
        },
        [updateProperty.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly

            ToastCtl.error('Daten konnten nicht gespeichert werden')
        }
    }
})

export default propertySlice.reducer
